<app-traitement-data titre="IAHR" [sousTitre]="patient!.iahResiduel?.date | aLaDateDu"
    [statut]="patient!.iahResiduel | iahResiduelStatut">
    {{ (patient!.iahResiduel?.value | iahResiduel) ?? 'Pas de donnée' }}
</app-traitement-data>